import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';
import { getLocaleFromParams } from '@/utils/locale';

import { fetchFixedPageData } from '@/integrations/contentful';
import { commonServerSideProps } from '@/lib/commonPageStaticProps';
import { resolveContentDraftMode } from '@/lib/draftMode';
import { getGqlRegionFromLocale, getRegionFromLocale } from '@/lib/regions';
import { CacheHeaderType } from '@/lib/revalidate';
import { SeoConfigBuilder } from '@/lib/seo/SeoVariables';
import { SignInView } from '@/views/SignInView';

export const getServerSideProps: GetServerSideProps = commonServerSideProps(
  async (context) => {
    const draftMode = resolveContentDraftMode(context);
    const routerLocale = getLocaleFromParams(context?.params);
    const { channel, languageCode } = getGqlRegionFromLocale(routerLocale);
    const { country, locale } = getRegionFromLocale(routerLocale);

    const countryCode = country.slug;
    const contentfulLocale = locale.contentful ?? locale.locale;
    const data = await fetchFixedPageData(
      'my-account/login',
      contentfulLocale,
      languageCode,
      channel,
      countryCode,
      draftMode,
    );

    return {
      props: {
        cms: data.cms,
        localeMessages: data?.dictionary,
        seoConfig: new SeoConfigBuilder().setNoIndex().build(),
      },
    };
  },
  CacheHeaderType.FIXED_PAGE,
);
export default withFixedPageCommonProps(SignInView);
